var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEmailSubject = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 33,
    fill: "#fff",
    opacity: 0.001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.523,22.4H5.5A4.5,4.5,0,0,1,1,17.9V6.9A4.5,4.5,0,0,1,5.5,2.4H23.523a4.5,4.5,0,0,1,4.5,4.5V17.9a4.5,4.5,0,0,1-4.5,4.5ZM5.5,4.2A2.7,2.7,0,0,0,2.8,6.9V17.9a2.7,2.7,0,0,0,2.7,2.7H23.523a2.7,2.7,0,0,0,2.7-2.7V6.9a2.7,2.7,0,0,0-2.7-2.7Z",
    transform: "translate(0 7.6)",
    fill: "#3953fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.054,11.046l3.541,2.633a.925.925,0,0,0,.894.2.87.87,0,0,0,.606-.659.837.837,0,0,0-.319-.823L20.236,9.753C19.317,8.989,17.833,10.027,19.054,11.046Z",
    transform: "translate(-0.821 12.586)",
    fill: "#3953fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.648,11.046l-3.541,2.633a.925.925,0,0,1-.894.2.87.87,0,0,1-.606-.659.837.837,0,0,1,.319-.823l3.541-2.641C23.385,8.989,24.869,10.027,23.648,11.046Z",
    transform: "translate(-12.82 12.586)",
    fill: "#3953fb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.514,15.15a4.431,4.431,0,0,1-3.164-1.38L6.056,8.35a1.1,1.1,0,0,1-.3-.961.964.964,0,0,1,.579-.77.768.768,0,0,1,.854.231l5.293,5.41a2.767,2.767,0,0,0,4.071,0l5.293-5.41a.768.768,0,0,1,.854-.231.964.964,0,0,1,.579.77,1.1,1.1,0,0,1-.3.961l-5.293,5.42A4.431,4.431,0,0,1,14.514,15.15Z",
    transform: "translate(0 6.926)",
    fill: "#959cf2"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailSubject, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/emailSubject.24f17921.svg";
export { ForwardRef as ReactComponent };